import en from "./locales/en.json";
import es from "./locales/es.json";

export type Lang = "en" | "es";
export type Translations = typeof en;

/**
 * All UI strings live in JSON files under ./locales.
 * Adding a new language:
 *   1. Copy en.json to <lang>.json
 *   2. Translate values (keep keys/shape identical)
 *   3. Import + register here, then extend the Lang union.
 */
export const translations: Record<Lang, Translations> = {
  en: en as Translations,
  es: es as Translations,
};
